<template>
    <div class="search-drivers container-fluid r-aside">
      <loading :active.sync="isLoading" :can-cancel="true"></loading>

      <div class="id-badge">
        <!-- Logo -->
        <img :src="logo" class="badge-logo" alt="Company Logo" />

        <!-- Driver's Full Name -->
        <h1 class="driver-name">{{ full_name }}</h1>

        <!-- Driver's Image -->
        <div class="id-photo-wrapper">
          <img
            v-if="id_profile_image"
            class="id-photo"
            :src="randomImage(id_profile_image) + '&v=badgeweb'"
            alt="No profile picture"
          />
        </div>

        <!-- Vehicle Information -->
        <p class="vehicle-info">Vehicle: <br /><span class="common-badge">{{
            driver.vehicles &&
            driver.vehicles[0].year &&
            driver.vehicles[0].model &&
            driver.vehicles[0].id_make_vehicle &&
            driver.vehicles[0].id_make_vehicle.name
              ? driver.vehicles[0].year +
                " " +
                driver.vehicles[0].id_make_vehicle.name +
                " " +
                driver.vehicles[0].model
              : "N/A"
          }}</span></p>
        <p class="license-plate">License Plate: <br /><span class="common-badge">{{
            driver.vehicles && driver.vehicles[0].license_plate_number
              ? driver.vehicles[0].license_plate_number
              : "N/A"
          }}</span></p>
      </div>
          <!-- Buttons for printing and saving -->
    <div class="actions">
      <button @click="saveBadgeAsImage">Save as PDF</button>

    </div>
    <div id="link_steps">
      <a href="https://help.wingz.me/hc/en-us/articles/33435053306772-NEMT-Driver-ID-Badge-Step-by-Step-Instructions-for-Printing-and-Creating-your-badge" target="_blank">How to print and make your ID badge</a>
    </div>
    </div>
  </template>

  <script>
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  const html2canvas = require('@/assets/js/html2canvas.js');

  export default {
  metaInfo: {
    title: 'Verida Driver | Edit Profile',
  },
  name: 'EditProfile',
  data() {
    return {
      title: 'Driver Profile',
      data: {},
      logo: require('@/assets/badge_logo.png'),
      id_driver: null,
      driver: null,
      isLoading: false,
      full_name: null,
      id_profile_image: null,
      jsPDFLoaded: false,
    };
  },
  components: {
    Loading,
  },
  methods: {
    randomImage(image) {
      const timestamp = Math.random();
      const imageWithTimestamp = image.includes('?') ? `${image}&v=${timestamp}` : `${image}?v=${timestamp}`;
      return imageWithTimestamp;
    },

    async fetchUser() {
      const original_token = this.$route.query.token;
      if (!original_token) {
      let getuser = this.getUser();
      this.id_driver = getuser['id_user'];
      this.full_name = getuser['name_first'] + " " + getuser['name_last'];
      this.id_profile_image = getuser['id_profile_image']['url'];
      await this.getUserInfo()
      }else{

        try {
        // Decode the token
        const parts = original_token.split('.');
        const token = JSON.parse(this.b64DecodeUnicode(parts[1]));

        // Fetch user data
        const response = await this.$http.get(`${process.env.API_BASE_URL}users/${token.user_id}/`, {
          headers: {
            Authorization: `JWT ${original_token}`
          }
        });

        console.log("Login success", response.data);

        // Save user data locally
        const user = { ...response.data, token: original_token };
        localStorage.setItem('user', JSON.stringify(user));
        this.$store.dispatch('SAVE_USER', user);

        // Vue.prototype.$http.defaults.headers.common['Authorization'] = `JWT ${original_token}`;

        // Update user state
        await this.updateUserState(user);
      } catch (error) {
        console.error("Error fetching user:", error);
      }
      }

    },

    async updateUserState(user) {
      console.log("Processing user state...");
      if (!user || !user.id_user) {
        console.warn("User data is incomplete.");
        return;
      }

      // Update user-related data
      this.id_driver = user.id_user;
      this.full_name = `${user.name_first || ''} ${user.name_last || ''}`;
      this.id_profile_image = user.id_profile_image && user.id_profile_image.url
      ? user.id_profile_image.url
      : '';
      this.id_profile_image = encodeURI(this.id_profile_image);
      console.log("Calling getUserInfo...");
      await this.getUserInfo();
    },

    async getUserInfo() {
      if (!this.id_driver) {
        console.warn("Cannot fetch user info without a driver ID.");
        return;
      }



      this.isLoading = true;





      try {
        const original_token = this.$route.query.token;


        if (!original_token) {
        this.isLoading = true;
        this.$http
          .get(process.env.API_BASE_URL + 'users/' + this.id_driver + '/')
          .then(response => {
            console.log('user info response', response.data);
            this.driver = response.data;
          })
          .catch(error => {
            console.log(error);
          })
          .finally(() => {
            this.isLoading = false;
          });
        }else{
          const parts = original_token.split('.');
          const token = JSON.parse(this.b64DecodeUnicode(parts[1]));
          const response = await this.$http.get(`${process.env.API_BASE_URL}users/${this.id_driver}/`, {
            headers: {
            Authorization: `JWT ${original_token}`,
            },  
          });
          console.log("User info response", response.data);
          this.driver = response.data;
        
        }
          
          

      } catch (error) {
        console.error("Error fetching user info:", error);
      } finally {
        this.isLoading = false;
        console.log("Finished fetching user info.");
      }
    },


    // saveBadgeAsImage() {

    //   const badgeElement = document.querySelector(".id-badge");
    //   html2canvas.html2canvas(badgeElement, { scale: 2, allowTaint: false, useCORS: true }).then((canvas) => {
    //     const link = document.createElement("a");
    //     link.download = "id-badge.png";
    //     link.href = canvas.toDataURL("image/png");
    //     link.click();
    //   });
    // },
    // saveBadgeAsImage() {
    //   const badgeElement = document.querySelector(".id-badge");
    //   html2canvas.html2canvas(badgeElement, {
    //     scale: 2, // Render the canvas at high resolution
    //     allowTaint: false,
    //     useCORS: true,
    //   }).then((canvas) => {
    //     // Create a new canvas for resizing
    //     const resizedCanvas = document.createElement("canvas");
    //     const context = resizedCanvas.getContext("2d");

    //     // Set desired dimensions (in pixels)
    //     const targetWidth = 921; // 3.07 inches × 300 DPI
    //     const targetHeight = 1182; // 3.94 inches × 300 DPI
    //     resizedCanvas.width = targetWidth;
    //     resizedCanvas.height = targetHeight;

    //     // Draw the original canvas onto the resized canvas
    //     context.drawImage(canvas, 0, 0, targetWidth, targetHeight);

    //     const badgeUrl = resizedCanvas.toDataURL("image/png");
    //     if (window.ReactNativeWebView) {
    //       window.ReactNativeWebView.postMessage(JSON.stringify(badgeUrl));
    //     } 
    //     else {

    //     // Save the resized canvas as an image
    //     const link = document.createElement("a");
    //     link.download = "id-badge.png";
    //     link.href = badgeUrl;
    //     link.click();
    //     }
    //   });
    // }
    loadJsPDF() {
      if (!this.jsPDFLoaded) {
        const script = document.createElement("script");
        script.src = "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.4.0/jspdf.umd.min.js";
        script.onload = () => {
          this.jsPDFLoaded = true;
          console.log("jsPDF loaded");
        };
        document.head.appendChild(script);
      }
    },
    saveBadgeAsImage() {
  const { jsPDF } = window.jspdf; // Ensure jsPDF is available
  if (!jsPDF) {
    console.error("jsPDF is not available");
    return;
  }

  const badgeElement = document.querySelector(".id-badge");

  html2canvas.html2canvas(badgeElement, {
    scale: 4, // Render the canvas at high resolution
    allowTaint: false,
    useCORS: true,
  }).then((canvas) => {
    // Resize the canvas to match 300 DPI (921x1182 pixels)
    const resizedCanvas = document.createElement("canvas");
    const context = resizedCanvas.getContext("2d");

    // Set target dimensions in pixels (300 DPI)
    const targetWidth = 921;
    const targetHeight = 1182;
    resizedCanvas.width = targetWidth;
    resizedCanvas.height = targetHeight;

    // Draw the original canvas onto the resized canvas
    context.drawImage(canvas, 0, 0, targetWidth, targetHeight);

    // Convert the resized canvas to a data URL
    const imgData = resizedCanvas.toDataURL("image/png");

    // Create a jsPDF instance with the correct dimensions
    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: [78.05, 100.08], // 3.07 x 3.94 inches in millimeters
    });

    // Calculate position to center the image
    const pdfWidth = 78.05; // PDF width in mm
    const pdfHeight = 100.08; // PDF height in mm
    const imgWidth = 78.05; // Image width in mm (3.07 inches)
    const imgHeight = 100.08; // Image height in mm (3.94 inches)
    const xOffset = (pdfWidth - imgWidth) / 2;
    const yOffset = (pdfHeight - imgHeight) / 2;

    // Add the image to the PDF at the centered position
    pdf.addImage(imgData, "PNG", xOffset, yOffset, imgWidth, imgHeight);

    if (window.ReactNativeWebView) {
      const pdfData = pdf.output("datauristring");
      window.ReactNativeWebView.postMessage(JSON.stringify(pdfData));
    } 
    else {

    // Save the PDF
    pdf.save("id-badge.pdf");
    }

  });
}
  },
  async mounted() {
    this.loadJsPDF();
    const user = JSON.parse(localStorage.getItem('user'));
    console.log(user)
    if (user) {
      console.log("User found in local storage.");
      await this.updateUserState(user);
    } else {
      console.warn("User not found in local storage. Fetching user...");
      await this.fetchUser();
    }
  },
  async created() {
    // No action here, as mounted handles the logic
  },
};
  </script>
  
  <style scoped>
  .submit-button {
    margin-top: 10px;
  }
  
  .result {
    margin-top: 20px;
  }
  
  .table td,
  .table th {
    vertical-align: middle;
    padding: 0.85rem;
  }
  
  .table td .btn {
    float: right;
    position: absolute;
    right: 25px;
    transform: translateY(-50%);
    padding: 3px 12px;
  }
  .table th > div {
    position: relative;
    display: inline;
  }
  .table th > div .arrow-down {
    position: absolute;
    right: -13px;
    top: 40%;
  }
  .table-hover tbody tr.transaction-details:hover {
    background-color: transparent;
  }
  .table-hover tbody tr.transaction-details tr:hover {
    background-color: transparent;
  }
  tr.transaction-details .table-striped tbody tr:nth-of-type(odd):hover {
    background-color: #e9edf2;
  }
  
  .id-badge {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: white;
    padding: 20px;
    width: 90%; /* Responsive width */
    max-width: 400px; /* Limit max width for larger screens */
    height: auto; /* Allow height to adjust based on content */
    box-sizing: border-box;
    text-align: center; /* Center-align text */
    margin: 20px auto; /* Center the badge horizontally and add margin */
    border-radius: 8px; /* Slightly rounded corners for aesthetics */
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Subtle shadow for depth */
  }
  
  /* Logo Styling */
  .badge-logo {
    width: 40%; /* Responsive size */
    max-width: 200px; /* Limit max size */
    height: auto; /* Maintain aspect ratio */
    margin-bottom: 15px;
  }
  
  /* Driver's Name Styling */
  .driver-name {
    font-size: 24px; /* Larger text for prominence */
    font-weight: bold;
    margin: 10px 0;
  }

  .id-photo-wrapper {
  width: 120px; /* Desired square size */
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden; /* Hide overflow if needed */

}

.id-photo {
  max-width: 100%;
  max-height: 100%;
  margin: auto;
  border-radius: 8px;
}

  
  /* Vehicle and License Plate Info */
  .vehicle-info,
  .license-plate {
    font-size: 15px;
    color: #333;
    margin: 8px 0;
    text-transform: uppercase;
  }
  
  .common-badge {
    display: inline-block;
    background-color: #333;
    color: #fff;
    font-weight: bold;
    padding: 5px 8px;
    border-radius: 8px;
    margin-left: 5px;
    font-size: 14px;
    letter-spacing: 0.5px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  }

  .actions {
  display: flex;
  justify-content: center; /* Center horizontally */
  align-items: center; /* Center vertically */
  margin-top: 20px; /* Add space above the button */
}

.actions button {
  background-color: #555; /* Use a neutral, complementary color */
  color: #fff; /* Keep the text white for contrast */
  padding: 12px 24px; /* Larger padding for a premium feel */
  font-size: 16px; /* Adjust font size for readability */
  border: none; /* Remove default borders */
  border-radius: 25px; /* Add rounded corners to match badge style */
  cursor: pointer; /* Change cursor to pointer on hover */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Subtle shadow for depth */
  transition: all 0.3s ease-in-out; /* Smooth transition for hover effects */
}

/* Hover effect for button */
.actions button:hover {
  background-color: #333; /* Darken background slightly on hover */
  transform: translateY(-2px); /* Slightly lift the button */
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.2); /* Enhance shadow on hover */
}

#link_steps{
  font-size: 15px;
    color: #333;
    display: flex;
  justify-content: center; /* Center horizontally */
  align-items: center; /* Center vertically */
  margin-top: 20px; /* Add space above the button */
}

#link_steps a{
  font-size: 16px;
    color: #333;
    font-weight:600;
    text-decoration: underline;

}
  </style>
  


// WEBPACK FOOTER //
// src/components/IDBadgeWeb.vue